<template>
    <client-page>
        <mypage-layout title="마진 시뮬레이터">
            <div class="tit-wrap">
                <v-row class="row--sm">
                    <v-col cols="12">
                        <v-currency-field v-model="salePrice" v-bind="attrs_input2" label="판매가 (권장가 대비  ± 10% 범위 내로만 입력 가능)" />
                    </v-col>
                    <v-col cols="12">
                        <v-currency-field v-model="cost" v-bind="attrs_input2" label="공급가" />
                    </v-col>
                    <v-col cols="12">
                        <margin-commission v-model="commission" />
                    </v-col>
                    <v-col cols="12">
                        <margin-isconsigned v-model="isConsigned" />
                    </v-col>
                    <v-col cols="12">
                        <v-currency-field v-model="deliveryCharge" v-bind="attrs_input2" label="택배비" />
                    </v-col>
                    <v-col cols="12">
                        <v-currency-field v-model="otherExpenses" v-bind="attrs_input2" label="기타비용" />
                    </v-col>
                    <v-col cols="12">
                        <v-currency-field v-model="quantity" v-bind="attrs_input2" label="판매수량" />
                    </v-col>
                </v-row>
                <v-btn block color="primary" x-large class="mt-4 mt-md-6" @click="calc">결과 도출</v-btn>
            </div>
            <v-sheet color="grey lighten-5" rounded="xl" class="pa-4 pa-md-6 text-center">
                <v-row justify="center" class="results">
                    <v-col cols="6" xl="auto">
                        <div class="txt txt--xs">건당 순이익</div>
                        <div class="d-flex justify-center align-center">
                            <span class="tit--xxs font-weight-bold">{{ netProfit_perItem?.format?.() || 0 }}</span>
                            <span class="txt txt--xs txt--dark">원</span>
                        </div>
                    </v-col>
                    <v-col cols="6" xl="auto">
                        <div class="txt txt--xs">총 순이익</div>
                        <div class="d-flex justify-center align-center">
                            <span class="tit--xxs font-weight-bold">{{ netProfit_overall?.format?.() || 0 }}</span>
                            <span class="txt txt--xs txt--dark">원</span>
                        </div>
                    </v-col>
                    <v-col cols="6" xl="auto">
                        <div class="txt txt--xs">마진율</div>
                        <div class="d-flex justify-center align-center">
                            <span class="tit--xxs font-weight-bold">{{ percentage_margin?.format?.(2) || 0 }}</span>
                            <span class="txt txt--xs txt--dark">%</span>
                        </div>
                    </v-col>
                    <v-col cols="6" xl="auto">
                        <div class="txt txt--xs">순익분기 판매가</div>
                        <div class="d-flex justify-center align-center">
                            <span class="tit--xxs font-weight-bold">{{ breakeven_selling?.format?.() || 0 }}</span>
                            <span class="txt txt--xs txt--dark">원</span>
                        </div>
                    </v-col>
                </v-row>
            </v-sheet>
        </mypage-layout>
    </client-page>
</template>

<script>
import { attrs_input2 } from "@/assets/variables";

import ClientPage from "@/components/client/templates/client-page.vue";
import MypageLayout from "@/components/client/templates/mypage-layout.vue";
import MarginCommission from "@/components/client/mypage/margin/margin-commission.vue";
import MarginIsconsigned from "@/components/client/mypage/margin/margin-isconsigned.vue";

export default {
    components: {
        ClientPage,
        MypageLayout,
        MarginCommission,
        MarginIsconsigned,
    },
    setup: () => ({
        attrs_input2,
    }),
    data: () => ({
        salePrice: null,
        cost: null,
        commission: null,
        isConsigned: false,
        deliveryCharge: null,
        otherExpenses: null,
        quantity: null,

        netProfit_perItem: 0,
        netProfit_overall: 0,
        percentage_margin: 0,
        breakeven_selling: 0,
    }),
    methods: {
        calc() {
            let {
                //
                salePrice = 0,
                cost = 0,
                commission = 0,
                isConsigned = false,
                deliveryCharge = 0,
                otherExpenses = 0,
                quantity = 0,
            } = this;

            try {
                if (!salePrice) throw new Error("판매가를 입력해주세요");
                if (!cost) throw new Error("공급가를 입력해주세요");
                if (!quantity) throw new Error("판매수량을 입력해주세요");
            } catch (error) {
                alert(error.message);
                return;
            }

            let commissionValue = salePrice * commission;
            let consignedCharge = isConsigned ? 4000 : 0;

            this.netProfit_perItem = salePrice - cost - commissionValue - consignedCharge - deliveryCharge - otherExpenses;
            this.netProfit_overall = this.netProfit_perItem * quantity;
            this.percentage_margin = (this.netProfit_perItem / salePrice) * 100;
            this.breakeven_selling = (cost + commissionValue + deliveryCharge + consignedCharge + otherExpenses) / (1 - commission);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep(.v-input .v-label) {
    background: #fff;
    padding-right: 6px;
    &:not(.v-label--active) {
        top: 14px;
        font-size: 14px;
        color: var(--v-grey-lighten1);
    }
}
@media (min-width: 1200px) {
    .results {
        margin: -40px !important;
        > [class*="col"] {
            padding: 40px !important;
            &:not(:last-child) {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    top: 50%;
                    right: 0;
                    transform: translateY(-50%);
                    background-color: var(--v-grey-lighten4);
                    width: 1px;
                    height: 50px;
                }
            }
        }
    }
}
</style>
